<template>
  <v-container class="sign-card-container text-center pt-14 px-0 mx-0">
    <div class="top-icon-wrapper">
      <img
        :src="topIconImage"
        width="74px"
        height="74px"
        class="sign-top-icon"
      />
    </div>
    <h3>{{ title }}</h3>
    <div class="mx-12 mt-8 mb-12">
      <img :src="iconImage" width="124px" height="117px" class="ml-4" />
      <div class="mt-2 document-card-description">{{ iconDescription }}</div>
    </div>
    <v-btn
      color="primary"
      class="mb-4 sign-or-view-button"
      :loading="isSigning"
      :disabled="isButtonDisabled"
      @click="!isSigning && $emit('button-click')"
    >
      {{ buttonText }}
    </v-btn>
    <div v-if="isSigned" class="signed-overlay state-overlay">
      <img
        :src="signedImage"
        width="124px"
        height="117px"
        class="signed-icon"
      />
    </div>
    <div v-if="isDeclined" class="declined-overlay state-overlay">
      <img
        :src="declinedImage"
        width="124px"
        height="117px"
        class="signed-icon"
      />
    </div>
    <div v-if="isDisabled" class="disabled-overlay state-overlay" />
  </v-container>
</template>

<script>
export default {
  name: "SignCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    isSigned: {
      type: Boolean,
      required: true,
    },
    isSigning: {
      type: Boolean,
      default: false,
    },
    isDeclined: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isButtonDisabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: true,
    },
    topIcon: {
      type: String,
      required: true,
    },
    iconDescription: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },
  emits: ["button-click"],
  computed: {
    iconImage() {
      return require(`@/assets/icons/${this.icon}.svg`);
    },
    topIconImage() {
      return require(`@/assets/icons/${this.topIcon}.svg`);
    },
    signedImage() {
      return require(`@/assets/icons/signed.svg`);
    },
    declinedImage() {
      return require(`@/assets/icons/declined.svg`);
    },
  },
};
</script>

<style scoped>
.sign-card-container {
  width: 360px;
  background: white;
  position: relative;
}

@media (max-width: 400px) {
  .sign-card-container {
    width: 300px;
  }
  .v-btn {
    padding: 12px 16px !important;
    font-size: 18px !important;
  }
}

.top-icon-wrapper {
  position: absolute;
  top: -37px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 4;
}

.sign-top-icon {
  position: relative;
}

.state-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.signed-overlay {
  background-color: rgba(66, 183, 0, 0.75);
  z-index: 3;
}

.declined-overlay {
  background-color: rgba(185, 1, 11, 0.75);
  z-index: 3;
}

.disabled-overlay {
  background-color: rgba(180, 180, 180, 0.75);
}

.signed-icon {
  width: 124px;
  height: 117px;
}

.sign-or-view-button {
  z-index: 2;
}

.document-card-description {
  font-size: 24px;
}
</style>
